import $ from "jquery";

document.addEventListener("DOMContentLoaded", function(event) {
  if (window.location.pathname.includes('keyword-tools')) {
    const pricing = {
      init: function() {
        this.swHandler();
      },
      swHandler: function() {
        $("#js-kwt_switcher").on("click", function() {
          if ($(this).find('input').attr("checked")) {
            $(this).find('input').attr("checked", false);
            $(this).find('.swSlider').css("-webkit-transform", "translateX(20px)");
            $(".btn_year").css("display", "none");
            $(".btn_month").css("display", "flex");
            $(".title_month").css("display", "block");
            $(".title_year").css("display", "none");
            pricing.dataHundler('yearly');
          } else {
            $(this).find('input').attr("checked", true);
            $(this).find('.swSlider').css("-webkit-transform", "translateX(0px)");
            $(".btn_month, .title_month").css("display", "none");
            $(".btn_year").css("display", "flex");
            $(".title_year").css("display", "block");
            pricing.dataHundler('monthly');
          }
          $('.kwt-sw__title').toggleClass('kwt-sw__title_active');
        });
      },
      dataHundler: function(status) {
        document.querySelectorAll('[data-monthly]').forEach(e => {
          if (e.tagName === 'A') {
            e.href = e.dataset[status];
          } else {
            e.innerHTML = `$${e.dataset[status]}<span>/mo</span>`;
          }
        });
      }
    }
    pricing.init();
  }
});
